import { render, staticRenderFns } from "./AddNewClient.vue?vue&type=template&id=0c6508ed&"
import script from "./AddNewClient.vue?vue&type=script&lang=js&"
export * from "./AddNewClient.vue?vue&type=script&lang=js&"
import style0 from "./AddNewClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports